import { ff } from '@atlassian/jira-feature-flagging';

export const isEndUserDiscoverOn = (): boolean => ff('enduser-emcee-discover');

/**
 *
 * When cleaning up this flag also ensure to clean up the code features store and the linked service.
 * src/packages/software/code/code-page/src/controllers/code-feature-store
 * src/packages/software/code/code-page/src/controllers/code-local-store
 *
 */
export const isBitbucketPendingConnectionBannerEnabled = (): boolean =>
	ff('otx-solaris-bbc-jsw-pending-integration-banner_ojmuc');
